import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchGet } from '@/api/PMS/baseInformation/customer';
import { getCompanyHouseList, insertCompanyHouse, fetchHouseTreeList } from '@/api/PMS/treeList/house';
import cloneDeep from 'lodash/cloneDeep';
import allocateHouses from './allocateHouses';
import { getToken } from '@/utils/auth'; // getToken from cookie

import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: ['keyValue', 'showDialog'],
  components: {
    allocateHouses: allocateHouses
  },
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'change'
        }],
        customerType: [{
          required: true,
          message: '请选择客户类别',
          trigger: 'change'
        }],
        customerName: [{
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        }],
        upIdListTwo: [{
          required: true,
          message: '请选择居住房屋地址',
          trigger: 'change'
        }],
        unRentTime: [{
          required: true,
          message: '请选择到租时间',
          trigger: 'change'
        }],
        rentTime: [{
          required: true,
          message: '请选择起租时间',
          trigger: 'change'
        }],
        companyAccountName: [{
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        }],
        companySimpleName: [{
          required: true,
          message: '请输入单位简称',
          trigger: 'blur'
        }],
        userSex: [{
          required: true,
          message: '请选择客户性别',
          trigger: 'blur'
        }],
        // userCardSerno: [
        //   { required: true, message: '请输入证件号码', trigger: 'blur' }
        // ],
        userPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        // companyAccountName: [
        //   { required: true, message: '请输入公司开户名称', trigger: 'blur' }
        // ],
        companyBankAccount: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        companyCreditCode: [{
          required: true,
          message: '请输入统一社会信用代码',
          trigger: 'blur'
        }],
        companyLegal: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        legalPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        companyPhoneFax: [{
          required: true,
          message: '请输入单位传真',
          trigger: 'blur'
        }],
        admin: [{
          required: true,
          message: '请输入管理员',
          trigger: 'blur'
        }],
        companyPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      roleId: '',
      linkageTree: {
        label: 'dicName',
        value: 'dicValue',
        children: 'dicList'
      },
      originUpIdList: [],
      checkedTreesNodes: [],
      // 选中的房间树节点
      // originNativeList: [],
      options: [],
      isDisabled: false,
      showPerson: true,
      childData: {
        upIdList: [],
        upIdListTwo: [],
        legalPhoneOne: '',
        houseName: []
      },
      upIdListTwo: [],
      dialogAllotFormVisible: false,
      addressOptions: [],
      industryType: [],
      // 行业类型
      unitType: [],
      // 单位类型
      manageLevel: [],
      // 管理级别
      files: [],
      fileList: [],
      changeFileList: [],
      delImg: [],
      dialogImageUrl: '',
      dialogVisible: false,
      importHeaders: {
        'access-token': getToken()
      },
      companyTypeList: [],
      managementLevelList: [],
      industryTypeList: [],
      List1: [],
      fangwu: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    console.log(this.keyValue, ']]]');
    this.loadIndustryTypeOptions();
    this.loadCompanyTypeOptions();
    this.loadManagementLevelOptions();
    this.init();
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
  },
  methods: {
    init: function init() {
      var _this = this;

      this.changeFileList = [];
      this.delImg = [];
      this.files = [];
      this.fileList = [];
      this.addressOptions = [];
      this.isDisabled = false;
      this.loadMenuTree();
      this.loadMenuTree1();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        console.log('...');
        this.isDisabled = true;
        var queryData = {
          companyId: this.keyValue
        };
        fetchGet(queryData).then(function (response) {
          _this.childData = response.data.data; // this.childData.companyCreditCode = this.childData.userCardSerno
          // this.childData.legalPhoneOne = this.childData.phone

          _this.$set(_this.childData, 'legalPhoneOne', _this.childData.phone);

          _this.$set(_this.childData, 'companyAccountName', _this.childData.companyName);

          _this.$set(_this.childData, 'companyCreditCode', _this.childData.userCardSerno); // this.childData.companyAccountName = this.childData.companyName


          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');
          _this.childData.deleteCompanyImgVo = {};

          if (_this.childData.companyImgListVos !== null) {
            _this.childData.companyImgListVos.forEach(function (item) {
              var imgData = {
                fileId: item.imgPath,
                fileType: 2,
                companyId: item.companyId,
                imgPath: item.imgPath,
                imgId: item.imgId,
                url: _this.downloadUrl + item.imgPath
              };

              _this.fileList.push(imgData);
            });

            _this.files = cloneDeep(_this.fileList);
          }
        });
        var data2 = [];
        getCompanyHouseList({
          companyId: this.keyValue
        }).then(function (res) {
          res.data.data.forEach(function (e) {
            data2.push(e.houseName);
          });
          console.log(data2, 'data222222');
          _this.fangwu = data2; // this.childData.houseName = data2;
          // this.$set(this.childData,'houseNamess',data2)
        });
      } else {
        console.log('///');
        this.fangwu = [];
        this.childData = {
          userSex: 1,
          customerType: 2,
          legalPhoneOne: '',
          houseName: [],
          companyImgListVos: [],
          deleteCompanyImgVo: {
            ids: []
          }
        };
      }
    },
    handCancle11: function handCancle11(reload) {
      if (reload) {
        this.init();
      }

      this.dialogAllotFormVisible = false;
    },
    handleSelectRoom: function handleSelectRoom() {
      if (this.childData.areaGroupId) {
        this.dialogFormVisible = true;
        this.checkedTreesNodes = this.houseList.map(function (item) {
          return item.resourceId;
        });
      } else {
        this.$message({
          message: '请先选择小区名称',
          type: 'error',
          duration: 3000
        });
      }
    },
    getTreeData: function getTreeData(data) {
      console.log('shoudaoshuju', data); // this.childData.houseList = data

      this.List1 = data;
    },
    // 配置fangwu
    handleallotAuthorize: function handleallotAuthorize() {
      if (true) {
        this.dialogAllotFormVisible = true;
        this.roleId = this.keyValue; // this.checkedTreesNodes = this.houseList.map(item => {
        //   return item.resourceId
        // })
        // this.checkedTreesNodes = this.List1.map(item => {
        //   // return item.resourceId
        //   item.id
        // })
      } else {
        this.$message({
          message: '请先选择小区名称',
          type: 'error',
          duration: 3000
        });
      } // this.roleId = 1
      // this.roleId = roleId
      // this.dialogAllotFormVisible = true

    },
    handCreate: function handCreate() {
      var _this2 = this;

      var startTime = new Date(this.childData.rentTime.replace(/-/g, "/"));
      var endTime = new Date(this.childData.unRentTime.replace(/-/g, "/"));

      if (startTime.getTime() > endTime.getTime()) {
        this.Alert({
          alertType: 'error',
          message: '起租时间不能早于到租时间'
        });
        return;
      }

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          // if(this.childData) {
          //   console.log(this.childData,'unRentTime')
          //   return
          // }
          if (_this2.childData.upIdList && _this2.childData.upIdList.length > 0) {
            _this2.childData.areaGroupId = _this2.childData.upIdList[_this2.childData.upIdList.length - 1];
          } // this.childData.changeCompanyImgVos = this.changeFileList
          // this.childData.deleteCompanyImgVo.ids = this.delImg


          if (_this2.keyValue > 0) {
            delete _this2.childData.upIdList; // this.childData.changeCompanyImgVos.forEach(item => {
            //   item.companyId = this.childData.companyId
            // })

            _this2.childData.houseList = _this2.List1;
            _this2.childData.customerType = 2;
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              } else {
                _this2.childData.upIdList = _this2.originUpIdList;
              }
            });
          } else {
            _this2.originUpIdList = _this2.childData.upIdList;
            delete _this2.childData.upIdList;
            _this2.childData.houseList = _this2.List1;
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              } else {
                _this2.childData.upIdList = _this2.originUpIdList;
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    resetForm: function resetForm() {
      if (this.childData.customerType === 1) {
        this.childData = {
          userSex: 1,
          customerType: 1
        };
        this.$refs['dataForm'].clearValidate();
      } else {
        this.childData = {
          customerType: 2
        };
        this.$refs['dataForm'].clearValidate();
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    loadMenuTree1: function loadMenuTree1() {
      var _this4 = this;

      var treeQuery = {
        flag: 0
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this4.addressOptions = response.data.data;
      });
    },
    loadIndustryTypeOptions: function loadIndustryTypeOptions() {
      var _this5 = this;

      fetchListByType('industry_type').then(function (res) {
        _this5.industryTypeList = res.data.data;
      });
    },
    loadCompanyTypeOptions: function loadCompanyTypeOptions() {
      var _this6 = this;

      fetchListByType('company_type').then(function (res) {
        _this6.companyTypeList = res.data.data;
      });
    },
    loadManagementLevelOptions: function loadManagementLevelOptions() {
      var _this7 = this;

      fetchListByType('management_level').then(function (res) {
        _this7.managementLevelList = res.data.data;
      });
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.customerType === val;
      });
      this.childData.customerType = obj.dicName;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    },
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
      this.changeFileList.push({
        name: response.data[0].fileName,
        imgName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type),
        imgPath: response.data[0].fileId,
        fileId: response.data[0].fileId
      });
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传7个文件!',
        type: 'danger'
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].failId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'JPEG' || extension === 'png' || extension === 'bmp' || extension === 'gif';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/jpeg/png/bmp/gif 格式文件!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this8 = this;

      var currentUrl = 0; // 获取当前删除文件的fileId

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.fileId;
        this.delImg.push(file.imgId);
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this8.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this8.fileList.splice(index, 1);

          return;
        }
      });
      this.changeFileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this8.changeFileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg' || str === 'image/gif' || str === 'image/bmp') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};